import { render, staticRenderFns } from "./RssIcon.vue?vue&type=template&id=6b554276&"
import script from "./RssIcon.vue?vue&type=script&lang=js&"
export * from "./RssIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports